<div class="content" *ngIf="manifest" style="padding: 5px">
  <form (submit)="save()" #formRef="ngForm" autocomplete="off">
    <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
      <em class="material-icons">warning</em>
      <span class="sr-only">Error:</span> {{errorMsg}}
    </div>
    <div class="row">
      <div class="col-md-8">
        <div
          class="help-block h4"
          [ngStyle]="{ cursor: !formRef.form.valid ? 'not-allowed' : 'pointer' }"
        >
          Manifest Entry {{ manifest.shipped ? "(Shipped)" : "" }}

          <close-button></close-button>
          <button
            type="submit"
            class="btn btn-outline-secondary pull-right"
            [disabled]="!(formRef.form.valid)"
          >
            <mat-icon title="Save">save</mat-icon>
          </button>
          <button
            *ngIf="manifest.canDelete"
            type="button"
            (click)="remove(manifest.id)"
            class="btn btn-outline-secondary pull-right"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <hr />
      </div>
    </div>
    <div class="card" title="Header">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="wasteType">Waste Type</label>
              <!-- Prevent to change the type if there are containers assigned -->
              <select
                [disabled]="!manifest.isNew"
                required
                class="form-select"
                [(ngModel)]="manifest.wasteType"
                name="wasteType"
              >
                <option *ngFor="let k of wasteTypeOptions" [value]="k">{{k}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="trackingNumber">Tracking Number</label>
              <input
                required
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="manifest.trackingNumber"
                name="trackingNumber"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="shippingDate">Shipping Date</label>
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="manifest.shippingDate"
                name="shippingDate"
                bsDatepicker
                [(bsValue)]="manifest.shippingDate"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="totalPages"> Pages </label>
              <input
                readonly
                required
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="manifest.totalPages"
                name="totalPages"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" title="Generator">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <input-filter
                required
                [data]="generators"
                [required]="true"
                [searchertext]="'Generator Company'"
                [searchText]="manifest.generatorCompany"
                (itemSelectedEvent)="setGenerator($event)"
              >
              </input-filter>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="generatorId">Generator ID</label>
              <input
                required
                type="text"
                class="form-control"
                autocomplete="off"
                [(ngModel)]=" manifest.generatorId"
                name="generatorId"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="generatorMailingAddress">Generator Mailing Address</label>
              <input
                type="text"
                class="form-control"
                autocomplete="off"
                [(ngModel)]=" manifest.generatorMailingAddress"
                name="generatorMailingAddress"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="emergencyPhone">Emergency Phone</label>
              <input
                required
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="manifest.emergencyPhone"
                name="emergencyPhone"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="generatorPhone">Generator Phone</label>
              <input
                type="text"
                class="form-control"
                autocomplete="off"
                [(ngModel)]="manifest.generatorPhone"
                name="generatorPhone"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="generatorName">Attention To</label>
              <input
                type="text"
                class="form-control"
                autocomplete="off"
                [(ngModel)]="manifest.generatorName"
                name="generatorName"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" title="Transporters">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <input-filter
              [data]="transporters"
              [key]="'company'"
              [searchertext]="'Transporter 1 Company'"
              [searchText]="manifest.transporter1Company"
              (itemSelectedEvent)="setTransporter1($event)"
            ></input-filter>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="transporter1Epaid">Transporter 1 EPAID</label>
              <div name="transporter1Epaid" class="ManifestEditorList">
                {{manifest.transporter1Epaid}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <input-filter
              [data]="transporters"
              [key]="'company'"
              [searchertext]="'Transporter 2 Company'"
              [searchText]="manifest.transporter2Company"
              (itemSelectedEvent)="setTransporter2($event)"
            ></input-filter>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="transporter2Epaid">Transporter 2 EPAID</label>
              <div name="transporter2Epaid" class="ManifestEditorList">
                {{manifest.transporter2Epaid}}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="transporterName">Transporter Name</label>
              <input
                type="text"
                class="form-control"
                autocomplete="off"
                [(ngModel)]="manifest.transporterName"
                name="transporterName"
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <div>
                <label for="transporterDate">Transporter Date</label>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  [(ngModel)]="manifest.transporterDate"
                  name="transporterDate"
                  bsDatepicker
                  [(bsValue)]="manifest.transporterDate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" title="Destination Facility">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <input-filter
              [data]="facilities"
              [key]="'facilityName'"
              [searchertext]="'Destination Facility'"
              [searchText]="manifest.facilityName"
              (itemSelectedEvent)="setFacility($event)"
            ></input-filter>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="facilityEpaid">EPAID</label>
              <div name="facilityEpaid" class="ManifestEditorList">{{manifest.facilityEpaid}}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="facilityAddress">Address</label>
              <div name="facilityAddress" class="ManifestEditorList">
                {{manifest.facilityAddress}}
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="facilityPhone"> Facility Phone</label>
              <div name="facilityPhone" class="ManifestEditorList">{{manifest.facilityPhone}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" title="Handling Instructions">
      <div class="row" *ngFor="let inst of manifest.manifestInstructions; let i=index">
        <div class="col-md-12">
          <div class="form-group">
            <label class="h6" [for]="'inst_' + i">
              Special Handling Instructions - Page #{{i+1}}</label
            >
            <textarea
              class="form-control"
              rows="4"
              [name]="'inst_' + i"
              [(ngModel)]="manifest.manifestInstructions[i].specialInstructions"
            >
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="card" title="Containers Header">
      <div class="card-header">
        <div class="row">
          <div class="col-md-1">
            <dl>
              <dt>
                <a
                  class="circle circle-add"
                  *ngIf="manifest.canManageContainers && !manifest.isNew"
                  title="Add new Container"
                  (click)="navigateToAddContainer()"
                >
                  <em style="color: red" class="material-icons-outlined">create</em> </a
                ><br />Container
              </dt>
            </dl>
          </div>
          <div class="col-md-2">
            <dl>
              <dt>Container Detail</dt>
            </dl>
          </div>
          <div class="col-md-3">
            <dl><dt>U.S Dot Description</dt></dl>
          </div>
          <div class="col-md-2">
            <dl><dt style="position: relative; left: 40%">TDSF</dt></dl>
            <div class="row">
              <div class="col-md-6">
                <dl><dt>Disposal Code</dt></dl>
              </div>
              <div class="col-md-6">
                <dl><dt>Profile</dt></dl>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <dl><dt style="position: relative; left: 40%">&nbsp;</dt></dl>
            <div class="row">
              <div class="col-md-6">
                <dl><dt>Weight</dt></dl>
              </div>
              <div class="col-md-6">
                <dl><dt>Volume</dt></dl>
              </div>
            </div>
          </div>
          <div class="col-md-1">
            <dl><dt>Waste Codes</dt></dl>
          </div>
          <div class="col-md-1"></div>
        </div>
      </div>
    </div>
    <div title="Containers List">
      <div *ngFor="let container of containers; let i = index" class="card">
        <div class="row" title="Container Row">
          <div class="col-md-1">
            <dd>
              <a
                class="circle"
                title="View details"
                routerLink="/containers/{{container.containerNumber}}"
              >
                <em class="material-icons-outlined">visibility</em>
              </a>
              <a
                title="Modify"
                class="circle"
                *ngIf="manifest.canManageContainers"
                routerLink="/containers/{{container.containerNumber}}/edit"
              >
                <em class="material-icons">edit</em>
              </a>
              &nbsp; {{i+1 | number:'2.0'}} - {{container.containerNumber}}
            </dd>
          </div>

          <div class="col-md-2">
            <dd>{{container.containerDetail}}</dd>
          </div>
          <div class="col-md-3">
            <dd>{{container.dotDescription}}</dd>
          </div>
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-6">
                <dd>{{container.tsdfDisposalCode}}</dd>
              </div>
              <div class="col-md-6">
                <dd>{{container.tsdfProfile}}</dd>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-6">
                <dd>{{container.weightUn}}</dd>
              </div>
              <div class="col-md-6">
                <dd>{{container.volumeUn}}</dd>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <dd>({{container.stateWasteCode}}) {{container.wasteCodesJoin}}</dd>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
